import { useEffect, useState} from "react";
import useAccountData from "hooks/useAccountData";
import LoadingScreen from "components/LoadingScreen";
import MyCompanies from "./MyCompanies";
import NoCompany from "./NoCompany";

export default function GetCompany(){
  const [companies, setCompanies] = useState(false);
  const { getCompanies, loadingCompanies} = useAccountData();

  const DisplayCompanies = () => {
    return companies ? <MyCompanies /> : <NoCompany />
  }

  useEffect(() => {
    async function fetchData() {
      if(!loadingCompanies) {
        const response = await getCompanies();
        if(response != null && response.length > 0) {
          setCompanies(true);
        }
      }
    }
    fetchData();
    
  }, [getCompanies, loadingCompanies]);
  return (
    <>
    {loadingCompanies ? (<LoadingScreen />) : (<DisplayCompanies />)}
    </>
  );
};
